// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Usage_usageContainer__LDj0w {
    padding: 5%;
}

.Usage_tableContainer__4y9XB {
    max-height: 70vh;
    overflow-y: auto;
    border: 1px solid #ccc;
    width: 100%;
}

.Usage_sortImg__mIwfY{
    height:18px;
    width:18px;
    /* margin-left: 6px; */
    /* flex-shrink: 0; */
    /* flex-direction: column-reverse; */
    position: absolute;
    right: 3%;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    margin-left: 15px;
}

.Usage_tableContainerTh__QMWdp{
    /* display: flex; */
    justify-content: center;
    align-items: center;
    position: relative;
}

@media (max-width: 480px) {
    .Usage_tableContainerTh__QMWdp {
      padding-right: 32px; /* more space for icon */
    }
  }`, "",{"version":3,"sources":["webpack://./src/Pages/Usage/Usage.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,UAAU;IACV,sBAAsB;IACtB,oBAAoB;IACpB,oCAAoC;IACpC,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,2BAA2B;IAC3B,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI;MACE,mBAAmB,EAAE,wBAAwB;IAC/C;EACF","sourcesContent":[".usageContainer {\n    padding: 5%;\n}\n\n.tableContainer {\n    max-height: 70vh;\n    overflow-y: auto;\n    border: 1px solid #ccc;\n    width: 100%;\n}\n\n.sortImg{\n    height:18px;\n    width:18px;\n    /* margin-left: 6px; */\n    /* flex-shrink: 0; */\n    /* flex-direction: column-reverse; */\n    position: absolute;\n    right: 3%;\n    top: 50%;\n    transform: translateY(-50%);\n    cursor: pointer;\n    margin-left: 15px;\n}\n\n.tableContainerTh{\n    /* display: flex; */\n    justify-content: center;\n    align-items: center;\n    position: relative;\n}\n\n@media (max-width: 480px) {\n    .tableContainerTh {\n      padding-right: 32px; /* more space for icon */\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"usageContainer": `Usage_usageContainer__LDj0w`,
	"tableContainer": `Usage_tableContainer__4y9XB`,
	"sortImg": `Usage_sortImg__mIwfY`,
	"tableContainerTh": `Usage_tableContainerTh__QMWdp`
};
export default ___CSS_LOADER_EXPORT___;
